import React from 'react';
import { Panel, Breadcrumb } from 'rsuite';

import { useTranslation } from 'react-i18next';
import ScheduleProfiles from './ScheduleProfiles';

const Page = () => {
  const { t } = useTranslation();
  return (
    <Panel
      header={
        <>
          <h3 className="title">{t('Home Office Planning')}</h3>{' '}
          <Breadcrumb>
            <Breadcrumb.Item href="/">{t('Home')}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t('Home Office Planning')}</Breadcrumb.Item>
          </Breadcrumb>
        </>
      }
    >
      <Panel
        bodyFill
        style={{
          // background: '#fff',
          padding: 20
        }}
      >
        <ScheduleProfiles />
      </Panel>
    </Panel>
  );
};

export default Page;
